var objectTraverse = require('./object-traverse');

var Blob = window.Blob;
var File = window.File;
var FileList = window.FileList;
var FormData = window.FormData;

var toString = Object.prototype.toString;
var forEach = Array.prototype.forEach;
var map = Array.prototype.map;

/**
 * Returns type of anything
 * @param {Object} any
 * @returns {String}
 */
function getType(any) {
    return toString.call(any).slice(8, -1);
}
/**
 * Converts path to FormData name
 * @param {Array} path
 * @returns {String}
 */
function toName(path) {
    var array = map.call(path, function(value) {
        return '[' + value + ']';
    });
    array[0] = path[0];
    return array.join('');
}

/**
 * Converts object to FormData
 * @param {Object} object
 * @returns {FormData}
 */
function toFormData(object) {
    var form = new FormData();
    var cb = function(node, value, key, path) {
        var type = getType(value);
        var name;

        switch (type) {
            case 'Array':
                break; // step into
            case 'Object':
                break; // step into
            case 'FileList':
                forEach.call(value, function(item, index) {
                    var way = path.concat(index);
                    var name = toName(way);
                    form.append(name, item);
                });
                return true; // prevent step into
            case 'File':
                name = toName(path);
                form.append(name, value);
                return true; // prevent step into
            case 'Blob':
                name = toName(path);
                form.append(name, value, value.name);
                return true; // prevent step into
            default:
                name = toName(path);
                if(value === null) {
                    form.append(name, "");
                } else if (value === false) {
                    form.append(name, 0);
                } else if (value === true) {
                    form.append(name, 1);
                } else if (value !== undefined) {
                    form.append(name, value);
                } else {
                    form.append(name, "");
                }

                return true; // prevent step into
        }
    };

    objectTraverse(object, cb, null, null, true);

    return form;
}

module.exports = toFormData;



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/to-form-data.js